import script from "./GastronomyStickyCTA.vue?vue&type=script&setup=true&lang=ts"
export * from "./GastronomyStickyCTA.vue?vue&type=script&setup=true&lang=ts"

import "./GastronomyStickyCTA.vue?vue&type=style&index=0&id=0e3fe1aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e3fe1aa"]])

export default __exports__